// Dependencies
import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// Components
import ContactUsMenu from './components/ContactUsMenu';

// Actions
import { updateMapType } from './actions';

// Shapes & Types
import { gMapTypeIdType } from './propTypesShapes';

// Assets
import './index.css';

// Constants
import { SETTINGS, MAP } from './constants';

// Utils
import { isFirstRender } from '../shared/utils/data';


const settingsOptions = Object.freeze({
  [`${SETTINGS.VIEW}`]: {
    'Street Map': { action: MAP.TYPE_ID.ROADMAP },
    Terrain: { action: MAP.TYPE_ID.TERRAIN },
    Satellite: { action: MAP.TYPE_ID.SATELLITE },
    Hybrid: { action: MAP.TYPE_ID.HYBRID }
  }
  /*,
  [`${SETTINGS.DOCUMENTS}`]: {
    action: '/documents'
  },
  [`${SETTINGS.REGION}`]: {
    action: '/region'
  },
  [`${SETTINGS.LANGUAGE}`]: {
    action: '/language'
  }*/,
  [`${SETTINGS.CONTACT_US}`]: {
    [`${SETTINGS.CONTACT_US}`]: <ContactUsMenu />
  }
});


class Settings extends Component {
  static propTypes = {
    mapTypeId: gMapTypeIdType
  };

  constructor(props) {
    super(props);
    const { mapTypeId } = props;
    let firstTierStatus = null;

    if (!isFirstRender(settingsOptions)) {
      firstTierStatus = {};

      Object.keys(settingsOptions).forEach(optionName => {
        firstTierStatus[optionName] = {
          hasChildren: !settingsOptions[optionName].action,
          expanded: false,
          selectedOption: null
        };

        switch (optionName) {
          case SETTINGS.VIEW: {
            const suboptionName = Object.keys(settingsOptions[optionName]).find(sName => {
              const suboptionObj = settingsOptions[optionName][sName];
              return suboptionObj.action && suboptionObj.action === mapTypeId;
            });
            firstTierStatus[optionName].selectedOption = suboptionName;
            break;
          }

          default: break;
        }

      });
    }

    this.state = { firstTierStatus };

    this.handleFirstTierOnClick = this.handleFirstTierOnClick.bind(this);
    this.handleSecondTierOnClick = this.handleSecondTierOnClick.bind(this);
  }

  handleFirstTierOnClick(optionName) {
    const { firstTierStatus } = this.state;
    const newFirstTierStatus = { ...firstTierStatus };

    Object.keys(newFirstTierStatus).forEach(oName => {
      newFirstTierStatus[oName] = {
        ...firstTierStatus[oName],
        expanded: oName === optionName
          ? !firstTierStatus[optionName].expanded
          : false
      };
    });


    this.setState({ firstTierStatus: newFirstTierStatus });
  }

  selectSuboption(optionName, suboptionName) {
    const { firstTierStatus } = this.state;
    const newFirstTierStatus = { ...firstTierStatus };

    // Object.keys(newFirstTierStatus).forEach(oName => {
    //   newFirstTierStatus[oName] = {
    //     ...firstTierStatus[oName],
    //     selectedOption: oName === optionName
    //       ? suboptionName
    //       : false
    //   };
    // });

    newFirstTierStatus[optionName].selectedOption = suboptionName;

    this.setState({ firstTierStatus: newFirstTierStatus });
  }

  handleSecondTierOnClick(optionName, suboptionName) {
    const { dispatch } = this.props;
    const { action } = settingsOptions[optionName][suboptionName];

    if (action) {
      this.selectSuboption(optionName, suboptionName);

      switch (optionName) {
        case SETTINGS.VIEW: {
          dispatch(updateMapType( action ));
          break;
        }

        default: break;
      }
    }
  }

  render() {
    const { firstTierStatus } = this.state;

    if ( isFirstRender(settingsOptions) || isFirstRender(firstTierStatus) ) {
      return null;
    }

    return (
      <nav className="Settings">
        <ul className="MenuNavBar list-unstyled">
          {Object.keys(settingsOptions).map((optionName, index) =>
            <li className="MenuNavOption" key={index}>
              <span
                className={`MenuOptionLink ${firstTierStatus[optionName].hasChildren ? 'icon-arrow': ''}`}
                data-toggle="collapse"
                aria-expanded={firstTierStatus[optionName].expanded}
                onClick={() => this.handleFirstTierOnClick(optionName)}
              >
                {optionName}
              </span>

              {firstTierStatus[optionName].hasChildren &&
                <ul className={`MenuTierContainer collapse list-unstyled ${
                  firstTierStatus[optionName].expanded ? 'show' :''}`}
                >
                  {Object.keys(settingsOptions[optionName]).map((suboptionName, index2) =>
                    <li
                      className={
                        `MenuNavOption ${suboptionName === firstTierStatus[optionName].selectedOption
                          ? 'active' : ''}`
                      }
                      key={index2}
                    >
                      {optionName === suboptionName ? (
                        <div className="MenuOptionContent">
                          {settingsOptions[optionName][suboptionName]}
                        </div>
                      ) : (
                        <span className="MenuOptionLink"
                          onClick={() => this.handleSecondTierOnClick(optionName, suboptionName)}
                        >
                          {suboptionName}
                        </span>
                      )}
                    </li>
                  )}
                </ul>
              }
            </li>
          )}
        </ul>
      </nav>
    );
  }
}

export default connect(({ settings }) => ({
  mapTypeId: settings.mapTypeId
}), null)(Settings);
